
<template>
        <div>
       <span class="small-label">商户名称：</span>
          <el-select
            class="el-select-relevant"
            v-model="mod_cooperatorIdLists"
            clearable
            placeholder="全部"
            @change="xhrCooperatorIdSelect"
          >
            <el-option
              v-for="item in parmesSelectDistributeChannel"
              :key="item.cooperatorId"
              :label="item.cooperatorName"
              :value="item.cooperatorId"
            ></el-option>
          </el-select>
        </div>
</template>

<script>
  import {HTTP_CODE} from "../../../service/axios_constants"
  export default {
    name: 'custom-element-select',
    props:{
      data:{
 
        default:this.parmesCooperatorIdList
      }
    },
    created(){
      this.xhrCooperatorIdSelect();
    },
    watch:{
      parmesCooperatorIdList(oldData,newData){
        this.$emit('update:data', newData);
      }
    },
    data(){
      return{
          mod_cooperatorIdLists:'',
          parmesSelectDistributeChannel:[],
          parmesCooperatorIdList:[],
      }
    },
    methods:{
      xhrCooperatorIdSelect(){
        console.log(HTTP_CODE)
         this.$http.postSelectCooperatorIdList().then(res => {
            if (res.statusCode === HTTP_CODE.suc) {
               this.parmesSelectDistributeChannel = res.data
               if (!this.mod_cooperatorIdLists) {
                  //如果 商户编号集合为空 设置商户编号为所有商户Id集合
                  this.parmesCooperatorIdList=this.parmesSelectDistributeChannel.map((item, index) => {
                     return item.cooperatorId
                  })
               }else{
                  this.parmesCooperatorIdList=this.mod_cooperatorIdLists
               }
            }
         })
          this.$emit('update:data', this.parmesCooperatorIdList);
      }
    }
  };
</script>


// WEBPACK FOOTER //
// src/components/my-element-select/src/main.vue